// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

let arrDomain = ["tasetco", "pcspost", "vintrans", "airlineexpress", "shipnhanh", "vietstarexpress"];
let hostname = location.hostname.split(".");
let domain = hostname.find(x => arrDomain.includes(x));

// domains name
const DOMAIN_TASETCO: string = "tasetco";
const DOMAIN_PCS: string = "pcspost";
const DOMAIN_VINTRANS: string = "vintrans";
const DOMAIN_AIRLINE: string = "airlineexpress";
const DOMAIN_SHIPNHANH: string = "shipnhanh";
const DOMAIN_VIETSTAREXPRESS: string = "vietstarexpress";
const DOMAIN_FLASHSHIP: string = "flashship";

var envir = {
  production: false,
  company: "DSC",
  title: "Post System Staging - DSC",
  name: "Post System Staging",
  namePrint: "",

  gMapKey: "AIzaSyCkR-wl8rYwyb5XhvinbcfZOuFsRV2IFDo",
  tokenFirebase: "AIzaSyAY9k6gMHd_wx-IiLyhzzYdKh_xhpOxKeM",
  urlFirebase: "https://fcm.googleapis.com/fcm/send",

  urlLogo: "",
  apiGeneralUrl: "",
  apiCRMUrl: "",
  apiPostUrl: "",

  hub: {
    centerHubLongName: "",
    centerHubSortName: "",
    poHubLongName: "",
    poHubSortName: "",
    stationHubLongName: "",
    stationHubSortName: "",
  },

  formatDate: "",
  formatDateTable: "",
  formatDateTime: "",
  formatDateTimeTable: "",

  firebase: {
    apiKey: "AIzaSyBwjHPz6q5c0lNukX_9q_UXD3SiviB8cOU",
    authDomain: "dsc-demo-cb5fb.firebaseapp.com",
    databaseURL: "https://dsc-demo-cb5fb.firebaseio.com",
    projectId: "dsc-demo-cb5fb",
    storageBucket: "dsc-demo-cb5fb.appspot.com",
    messagingSenderId: "631002885321"
  }
};

envir = getEnvironment(domain);

function getEnvironment(domainName: string) {

  envir.namePrint = "GSDP";
  envir.gMapKey = "AIzaSyBu4Y90CByGCKL5rxjR1bfCPAKVkh5KhYA";
  envir.urlLogo = "/assets/images/logo/gsdp.png";
  // envir.apiGeneralUrl= "http://coreapi.ssw.vn/api",
  // envir.apiGeneralUrl= "http://localhost:52724/api",
  // envir.apiCRMUrl = "http://crmapi.ssw.vn/api",
  // envir.apiPostUrl = "http://postapi.ssw.vn/api";
  envir.formatDate = "YYYY/MM/DD";
  envir.formatDateTable = "yyyy/MM/dd";
  envir.formatDateTime = "YYYY/MM/DD HH:mm";
  envir.formatDateTimeTable = "yyyy/MM/dd HH:mm";

  envir.apiGeneralUrl = "https://coreapi.gsdp.vn/api";
  envir.apiCRMUrl = "https://crmapi.gsdp.vn/api";
  envir.apiPostUrl = "https://postapi.gsdp.vn/api";
  // ng build
  // envir.apiGeneralUrl = "http://coreapitest.gsdp.vn/api";
  // envir.apiCRMUrl = "http://crmapitest.gsdp.vn/api";
  // envir.apiPostUrl = "http://postapitest.gsdp.vn/api";

  envir.hub.centerHubLongName = "Trung tâm";
  envir.hub.centerHubSortName = "TT";
  envir.hub.poHubLongName = "Chi nhánh";
  envir.hub.poHubSortName = "CN";
  envir.hub.stationHubLongName = "Bưu cục";
  envir.hub.stationHubSortName = "BC";

  envir.company = "GSDP";
  envir.title = "TMS";
  envir.name = "GSDP";

  return envir;
}

export const environment = envir;



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/environments/environment.ts